<template>
  <section>
    <div>
      <div class="title-channel">
        <div class="title" v-if="!fromTreeSection">
          <h3>Asigna identificadores al chatbot</h3>

          <p>
            Recuerda que se listarán solo aquellos identificadores que no se encuentren vinculados a
            alguna cola.
          </p>
        </div>

        <a-alert
          v-if="showWarning"
          message="¡Ups! Parece que ya tienes otro chatbot con el mismo identificador y horario seleccionados. Por favor, modifica uno de ellos para evitar cualquier interferencia."
          banner
        />

        <p>
          <selector-channels
            withoutVoice
            :value="channels_customers"
            :disabled="disabled"
            :channel="selectedChannel"
            @update:value="selectChannelCustomer($event)"
            isChatbot
            skipFilterQueue
          />
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent, ref, toRaw, inject, watch } from "vue";

import { ChannelType } from "@/app/shared/utils/enums";

import SelectorChannels from "@/app/shared/components/selectors/SelectorChannels.vue";
import { validateChannelCustomerSchedule } from "@/app/chatbots/services";

export default defineComponent({
  components: { SelectorChannels },
  props: {
    fromTreeSection: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedChannel: Number,
    showWarning: Boolean,
    validateSchedules: Boolean,
  },
  setup(_, { expose, emit }) {
    const chatbotDetails = inject("chatbotDetails");
    const channels_customers = ref(
      chatbotDetails?.value?.channels_customers?.map((channel) => channel.id) || []
    );

    const handleOk = (current) => {
      return current + 1;
    };

    expose({
      formState: {
        channels_customers: toRaw(channels_customers),
      },
      handleOk,
    });

    watch(channels_customers, () => emit("activate-button"), { deep: false });

    return {
      channels_customers,
      ChannelType,
    };
  },
  watch: {},
  methods: {
    handleReset() {
      this.channels_customers = [];
    },
    selectChannelCustomer(channels_customers) {
      this.channels_customers = channels_customers;
      console.log("selectChannelCustomer:", this.channels_customers);
      console.log("this.validateSchedules:", this.validateSchedules);
      if (this.validateSchedules) {
        this.$emit("handle-validate-schedules", channels_customers);
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.italic-style
  font-style: italic
  text-align: justify

.title
  text-align: center

  h3
    color: $gray-9
    margin-bottom: 12px
    font-size: 24px
    font-weight: 600

  p
    color: $gray-8
    font-size: 16px
    margin-bottom: 24px
</style>
